/* ------------------------------------------------------------------
   ol-b2b-form.js — Pre-remplit le form devis depuis querystring du configurateur.
   Querystring attendu : ?type=...&personnes=...&nuits=...&formule=...&services=...&notes=...
   Affiche un recap visuel (bloc "Votre projet configure") + alimente
   les hidden inputs pour transferer ces infos dans le mail Shopify.
   ------------------------------------------------------------------ */
(function () {
  'use strict';

  const sections = document.querySelectorAll('.ol-b2b-form');
  if (!sections.length) return;

  const TYPE_LABELS = {
    'seminaire': 'Séminaire',
    'team-building': 'Team Building',
    'comite-executif': 'Comité exécutif',
    'retraite': 'Retraite'
  };

  const FORMULE_LABELS = {
    'sans': 'Sans restauration',
    'pdj': 'Petit-déjeuner',
    'demi': 'Demi-pension',
    'pension': 'Pension complète'
  };

  function parseQueryParams() {
    try {
      const params = new URLSearchParams(window.location.search);
      return {
        type: params.get('type') || '',
        personnes: params.get('personnes') || '',
        nuits: params.get('nuits') || '',
        formule: params.get('formule') || '',
        services: params.get('services') || ''
      };
    } catch (e) {
      return { type: '', personnes: '', nuits: '', formule: '', services: '' };
    }
  }

  function hasAnyValue(p) {
    return !!(p.type || p.personnes || p.nuits || p.formule || p.services);
  }

  function plural(n, singular, plural) {
    return parseInt(n, 10) > 1 ? plural : singular;
  }

  function formatPersonnes(n) {
    if (!n) return '—';
    return n + ' ' + plural(n, 'personne', 'personnes');
  }

  function formatNuits(n) {
    if (!n) return '—';
    return n + ' ' + plural(n, 'nuit', 'nuits');
  }

  function setText(el, text) {
    if (el) el.textContent = text;
  }

  function setHidden(section, key, value) {
    const input = section.querySelector('[data-form-hidden="' + key + '"]');
    if (input) input.value = value || '';
  }

  function renderBadges(container, services) {
    container.innerHTML = '';
    services.forEach(label => {
      const li = document.createElement('li');
      li.className = 'ol-b2b-form__recap-badge';
      li.textContent = label;
      container.appendChild(li);
    });
  }

  function initSection(section) {
    const params = parseQueryParams();
    const has = hasAnyValue(params);

    const recapBlock = section.querySelector('[data-form-recap]');
    const servicesWrap = section.querySelector('[data-form-recap-services-wrap]');

    // Swap label + placeholder du champ Message selon contexte (config vs direct)
    const labelWrap = section.querySelector('.ol-b2b-form__label[data-form-body-label-config]');
    const labelText = section.querySelector('[data-form-body-label-text]');
    const labelOptional = section.querySelector('[data-form-body-optional]');
    const bodyTextarea = section.querySelector('[data-form-body-textarea]');

    if (labelWrap && labelText && bodyTextarea) {
      if (has) {
        // Mode "configurateur utilise" : optionnel
        labelText.textContent = labelWrap.dataset.formBodyLabelConfig;
        if (labelOptional) {
          labelOptional.textContent = labelWrap.dataset.formBodyOptionalConfig;
          labelOptional.style.display = '';
        }
        bodyTextarea.placeholder = bodyTextarea.dataset.formBodyPlaceholderConfig;
        bodyTextarea.required = false;
      } else {
        // Mode "acces direct" : requis, libelle invitant
        labelText.textContent = labelWrap.dataset.formBodyLabelDirect;
        if (labelOptional) {
          labelOptional.style.display = 'none';
        }
        bodyTextarea.placeholder = bodyTextarea.dataset.formBodyPlaceholderDirect;
        bodyTextarea.required = true;
      }
    }

    // Si pas de querystring : on garde le fieldset masque (hidden defaut du Liquid)
    if (!has) return;

    if (recapBlock) recapBlock.removeAttribute('hidden');

    const typeLabel = TYPE_LABELS[params.type] || params.type || '—';
    const formuleLabel = FORMULE_LABELS[params.formule] || params.formule || '—';

    setText(section.querySelector('[data-form-recap="type"]'), typeLabel);
    setText(section.querySelector('[data-form-recap="personnes"]'), formatPersonnes(params.personnes));
    setText(section.querySelector('[data-form-recap="nuits"]'), formatNuits(params.nuits));
    setText(section.querySelector('[data-form-recap="formule"]'), formuleLabel);

    const servicesArr = (params.services || '').split(',').map(s => s.trim()).filter(Boolean);
    if (servicesArr.length) {
      if (servicesWrap) servicesWrap.removeAttribute('hidden');
      const badgesEl = section.querySelector('[data-form-recap="services"]');
      if (badgesEl) renderBadges(badgesEl, servicesArr);
    }

    setHidden(section, 'type', typeLabel);
    setHidden(section, 'personnes', formatPersonnes(params.personnes));
    setHidden(section, 'nuits', formatNuits(params.nuits));
    setHidden(section, 'formule', formuleLabel);
    setHidden(section, 'services', servicesArr.join(', '));
  }

  // Submit handler : envoie le payload au Worker (qui envoie commercial + client),
  // attend la reponse, affiche success ou error UI inline. Pas de Shopify form natif.
  function initWorkerSubmit(section) {
    const workerUrl = section.getAttribute('data-worker-url');
    if (!workerUrl) {
      console.warn('[ol-b2b-form] data-worker-url manquant. Form desactive.');
      return;
    }

    const form = section.querySelector('[data-form-b2b]');
    if (!form) return;

    const submitBtn = form.querySelector('[data-form-submit]');
    const submitLabel = form.querySelector('[data-form-submit-label]');
    const submitLoading = form.querySelector('[data-form-submit-loading]');
    const successEl = section.querySelector('[data-form-status="success"]');
    const errorEl = section.querySelector('[data-form-status="error"]');

    function setLoading(loading) {
      if (!submitBtn) return;
      submitBtn.disabled = loading;
      if (submitLabel) submitLabel.hidden = loading;
      if (submitLoading) submitLoading.hidden = !loading;
    }

    function hideStatus() {
      if (successEl) successEl.hidden = true;
      if (errorEl) errorEl.hidden = true;
    }

    function showSuccess() {
      if (successEl) {
        successEl.hidden = false;
        successEl.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    }

    function showError() {
      if (errorEl) {
        errorEl.hidden = false;
        errorEl.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    }

    form.addEventListener('submit', async (e) => {
      e.preventDefault();
      hideStatus();

      const fd = new FormData(form);
      const params = parseQueryParams();
      const payload = {
        email: (fd.get('contact[email]') || '').toString().trim(),
        name: (fd.get('contact[name]') || '').toString().trim(),
        phone: (fd.get('contact[phone]') || '').toString().trim(),
        company: (fd.get('contact[company]') || '').toString().trim(),
        dates: (fd.get('contact[dates]') || '').toString().trim(),
        message: (fd.get('contact[body]') || '').toString().trim(),
        type: params.type || '',
        personnes: params.personnes || '',
        nuits: params.nuits || '',
        formule: params.formule || '',
        services: params.services || '',
      };

      // Validation minimale (HTML5 required l'a deja fait, ici filet)
      if (!payload.email || !payload.name) {
        showError();
        return;
      }

      setLoading(true);

      try {
        const resp = await fetch(workerUrl, {
          method: 'POST',
          headers: { 'Content-Type': 'text/plain' },
          body: JSON.stringify(payload),
        });
        const result = await resp.json().catch(() => ({}));

        // 200 = full success, 207 = partiel (au moins 1 mail parti), 4xx/5xx = erreur
        const ok = resp.status === 200 || (resp.status === 207 && result.ok);
        if (ok) {
          showSuccess();
          form.reset();
          // Cacher le bloc recap apres reset (querystring reste mais on a deja envoye)
          const recapBlock = section.querySelector('[data-form-recap]');
          if (recapBlock) recapBlock.setAttribute('hidden', '');
        } else {
          console.warn('[ol-b2b-form] worker error', resp.status, result);
          showError();
        }
      } catch (err) {
        console.warn('[ol-b2b-form] fetch exception', err);
        showError();
      } finally {
        setLoading(false);
      }
    });
  }

  sections.forEach(section => {
    initSection(section);
    initWorkerSubmit(section);
  });
})();
